/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserLoginStateResponse} from '../models/UserLoginStateResponse';
import type {UserLoginStateSaveRequest} from '../models/UserLoginStateSaveRequest';

export interface GetUserLoginPreconditions$Request {
    userId: number;
}

export interface GetUserLoginPreconditions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLoginPreconditionsRequest = createAction<PayloadData<void, GetUserLoginPreconditions$Request>>('USER_LOGIN_PRECONDITIONS__GET_USER_LOGIN_PRECONDITIONS__REQUEST');
export const getUserLoginPreconditionsSuccess = createAction<PayloadData<UserLoginStateResponse, GetUserLoginPreconditions$Request>>('USER_LOGIN_PRECONDITIONS__GET_USER_LOGIN_PRECONDITIONS__SUCCESS');
export const getUserLoginPreconditionsFailure = createAction<PayloadData<Error, GetUserLoginPreconditions$Request, true>>('USER_LOGIN_PRECONDITIONS__GET_USER_LOGIN_PRECONDITIONS__FAILURE');

export const getUserLoginPreconditionsActions = [
    getUserLoginPreconditionsRequest,
    getUserLoginPreconditionsSuccess,
    getUserLoginPreconditionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLoginPreconditions = (meta: GetUserLoginPreconditions$Request, config?: GetUserLoginPreconditions$Config) => {
    return {
        CALL_API: {
            types: getUserLoginPreconditionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/profile/login-preconditions`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserLoginPreconditions$Request {
    userId: number;
    userLoginStateSaveRequest?: UserLoginStateSaveRequest;
}

export interface SaveUserLoginPreconditions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserLoginPreconditionsRequest = createAction<PayloadData<void, SaveUserLoginPreconditions$Request>>('USER_LOGIN_PRECONDITIONS__SAVE_USER_LOGIN_PRECONDITIONS__REQUEST');
export const saveUserLoginPreconditionsSuccess = createAction<PayloadData<void, SaveUserLoginPreconditions$Request>>('USER_LOGIN_PRECONDITIONS__SAVE_USER_LOGIN_PRECONDITIONS__SUCCESS');
export const saveUserLoginPreconditionsFailure = createAction<PayloadData<Error, SaveUserLoginPreconditions$Request, true>>('USER_LOGIN_PRECONDITIONS__SAVE_USER_LOGIN_PRECONDITIONS__FAILURE');

export const saveUserLoginPreconditionsActions = [
    saveUserLoginPreconditionsRequest,
    saveUserLoginPreconditionsSuccess,
    saveUserLoginPreconditionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLoginStateSaveRequest} [meta.userLoginStateSaveRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserLoginPreconditions = (meta: SaveUserLoginPreconditions$Request, config?: SaveUserLoginPreconditions$Config) => {
    return {
        CALL_API: {
            types: saveUserLoginPreconditionsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/profile/login-preconditions`,
            TRANSPORT_REQUEST_BODY: meta.userLoginStateSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

